import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatApiError } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminEmailSettings() {
  const [data, setData] = useState(null);
  const [key, setKey] = useState("");
  const [sender, setSender] = useState("");
  const [clear, setClear] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    api.get("/admin/settings/email").then(({ data }) => { setData(data); setSender(data.sender); })
      .catch((e) => setError(formatApiError(e.response?.data?.detail)));
  }, []);
  const save = async (e) => {
    e.preventDefault(); setBusy(true); setError(""); setMessage("");
    try {
      const { data } = await api.put("/admin/settings/email", { sender, api_key: key || undefined, clear_key: clear });
      setData(data); setKey(""); setClear(false); setMessage("Email settings saved.");
    } catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return <form onSubmit={save} className="space-y-3 rounded-xl border border-slate-700 p-4">
    <h2 className="font-bold text-lg">Email verification</h2>
    <p className="text-xs text-slate-300">New accounts must verify their email. Existing accounts can continue signing in.</p>
    <p className="text-xs text-amber-300">{data?.configured ? "Resend key configured." : "No Resend key: the UI says OTP sent, but no email is delivered and registration cannot finish."}</p>
    <label className="block text-sm">Sender email (verified Resend domain)<Input type="email" required value={sender} onChange={(e) => setSender(e.target.value)} placeholder="no-reply@your-domain.com" /></label>
    <label className="block text-sm">Resend API key<Input type="password" autoComplete="new-password" value={key} onChange={(e) => setKey(e.target.value)} placeholder={data?.configured ? "Leave blank to keep current key" : "re_…"} /></label>
    <label className="flex gap-2 text-xs"><input type="checkbox" checked={clear} onChange={(e) => setClear(e.target.checked)} />Remove saved API key</label>
    {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
    {message && <p role="status" className="text-sm text-emerald-400">{message}</p>}
    <Button disabled={busy || !data} className="bg-emerald-400 text-black">{busy ? "Saving…" : "Save email settings"}</Button>
  </form>;
}
